import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import Colors from "../../assets/Colors";
import { useDesktopOrLaptop } from "../../services/useDesktopOrLaptop";

const CustomModal = ({
  children,
  isOpen,
  onClose,
  extraClasses,
  width = "45%",
}) => {
  const { isdesktop } = useDesktopOrLaptop();
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className={`fixed inset-0 overflow-y-auto ${extraClasses}`}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                style={{
                  maxWidth: isdesktop ? width : "80%",
                  backgroundColor: Colors.white,
                }}
                className="w-full overflow-hidden rounded-2xl text-left align-middle shadow-xl transition-all"
              >
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CustomModal;
